import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useStore } from '../../../contexts/store-provider';
import { getTenantIdFromLocalStorage } from '../../../helpers/localstorage-helper';
import { IFormModalProps } from '../../../models/forms/IForm';
import { IImportOrder } from '../../../models/forms/IImportHoliday';
import { formatMessage } from '../../../translations/format-message';
import ImportHolidayForm from '../forms/import-holiday-form';

const ImportHolidays = (props: IFormModalProps) => {
  const initialValues: IImportOrder = { file: '' };
  const { factoryScheduleStore } = useStore();
  const { holidaysFileUploadService, fileUploadState, resetFileUploadState } =
    factoryScheduleStore;

  useEffect(() => {
    if (fileUploadState.success) {
      onModalClosed();
    }
  }, [fileUploadState.success]);

  useEffect(() => {
    if (fileUploadState.error) {
      toast.error(formatMessage(fileUploadState.error));
      resetFileUploadState();
    }
  }, [fileUploadState.error]);

  const onSubmitForm = (values: any) => {
    holidaysFileUploadService(
      Number(getTenantIdFromLocalStorage()),
      values.file
    );
  };

  const onModalClosed = () => {
    props.modalClosed();
  };

  return (
    <React.Fragment>
      <ImportHolidayForm
        initialValues={initialValues}
        id={props.id}
        submitHandler={onSubmitForm}
        onModalClosed={onModalClosed}
        isLoading={fileUploadState.inProgress}
      />
    </React.Fragment>
  );
};

export default observer(ImportHolidays);
